var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("clip-loader", {
        attrs: { loading: _vm.loading, color: _vm.loadingColor, size: "20px" },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.drugData
        ? [
            _vm.drugData?.combined_drugs && _vm.drugData.combined_drugs.length
              ? _c(
                  "div",
                  { staticClass: "combined_drugs" },
                  [
                    _c("p", [_vm._v("Препарат состоит из компонентов")]),
                    _vm._v(" "),
                    _vm._l(_vm.drugData.combined_drugs, function (cd) {
                      return _c("p", { key: cd.combine_drug_id }, [
                        _vm._v(_vm._s(cd?.drug?.title) + " x\n        "),
                        _c("strong", [_vm._v(_vm._s(cd.rate))]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.siteDataInfo
              ? _c("p", { staticClass: "site_info_data" }, [
                  _vm._v(
                    "Данные на справочной: " +
                      _vm._s(_vm.siteDataInfo.title) +
                      " цена "
                  ),
                  _c("strong", [_vm._v(_vm._s(_vm.siteDataInfo.price))]),
                  _vm._v("р.\n    "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _vm._v("Страна поставки: "),
              _c("strong", [_vm._v(_vm._s(_vm.drugData.country.name))]),
            ]),
            _vm._v(" "),
            _vm.isHasValidDatesToDisplay()
              ? _c("div", { staticClass: "max-width-75" }, [
                  _c(
                    "p",
                    [
                      _vm._v("\n        Сроки годности:\n        "),
                      _vm._l(
                        _vm.getSortedValidDates(_vm.drugData.valid_dates),
                        function (d, i) {
                          return _c("span", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.printDate(d.expire_date, "MM.YYYY"))
                              ),
                            ]),
                            _vm._v(" "),
                            d.comment
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-dark" },
                                  [_vm._v(_vm._s(d.comment))]
                                )
                              : _vm._e(),
                            _vm._v(
                              _vm._s(
                                i + 1 < _vm.drugData.valid_dates.length
                                  ? ", "
                                  : null
                              )
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.storeData
              ? [
                  _c("StoreDataForOrder", {
                    attrs: {
                      updatedStoreData: _vm.updatedStoreData,
                      storeData: _vm.storeData,
                      locality: _vm.locality,
                      inRunnersStores: _vm.inRunnersStores,
                      drug: _vm.drug,
                    },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.drugData.order_details && _vm.drugData.order_details.length
              ? _c("p", [
                  _vm._v("последняя продажа:\n      "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.printDate(
                          _vm.drugData.order_details[0].order.report_date,
                          "DD.MM.YYYY"
                        )
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.drug.is_press_can &&
            _vm.divisionsWithAirDelivery[_vm.$editNewOrder.division_id]
              ? _c("div", { staticClass: "alert alert-warning mt-1 p-1" }, [
                  _c("i", { staticClass: "icon-fa icon-fa-warning" }),
                  _vm._v(
                    " Преперат в баллоне под давлением (авиа транспортировка невозможна)\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.analogs && _vm.analogs.length
              ? _c("div", { staticClass: "alert alert-info mt-1 mb-1 p-1" }, [
                  _c(
                    "div",
                    {
                      class: {
                        limitedView:
                          !_vm.showAllAnalogs && _vm.analogs.length > 4,
                      },
                    },
                    [
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            "Такое же действующее вещество: (" +
                              _vm._s(_vm.analogs.length) +
                              ")"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.analogs, function (analog) {
                        return _c("p", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.chooseAnalog(analog)
                                },
                              },
                            },
                            [_vm._v(_vm._s(analog.title))]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.analogs.length > 4
                    ? _c(
                        "p",
                        {
                          staticClass: "pointer text-right",
                          on: {
                            click: function ($event) {
                              _vm.showAllAnalogs = !_vm.showAllAnalogs
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.showAllAnalogs ? "Свернуть" : "Развернуть"
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.managerComments.length
        ? _vm._l(_vm.managerComments, function (c, i) {
            return _vm.allowToDisplay(c)
              ? _c(
                  "div",
                  { key: i, staticClass: "alert alert-info p-1 mb-1" },
                  [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._m(0, true),
                      _vm._v(" " + _vm._s(c.comment)),
                    ]),
                  ]
                )
              : _vm._e()
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "badge badge-info" }, [
      _c("i", { staticClass: "icon-fa icon-fa-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }